import { ConfigureView } from "../features/configuration/ConfigurationView";

export const ConfigurePage = ConfigureView;
